import React from "react";
import { DefaultOverview, DefaultTopics } from "./DefaultViews";
export const CommonConfigurationDiagnosticsOverview = () => {
    return <DefaultOverview />;
};
export const CommonConfigurationDiagnosticsTopics = () => {
    return <DefaultTopics />;
};
